"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviousOption = exports.getNextOption = exports.focusLastOption = exports.focusFirstOption = exports.focusOption = exports.doesFooterExist = exports.doesHeaderExist = exports.getOptionsArray = exports.getLastOption = exports.getFirstOption = void 0;
var getFirstOption = function (options, tree) {
    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
        var option = options_1[_i];
        if (option.options && !tree) {
            var firstOption = exports.getFirstOption(option.options, false);
            if (firstOption) {
                return firstOption;
            }
            continue;
        }
        if (!option.disabled) {
            return option;
        }
    }
    return null;
};
exports.getFirstOption = getFirstOption;
var getLastOption = function (options) {
    return exports.getFirstOption(__spreadArray([], options).reverse(), false);
};
exports.getLastOption = getLastOption;
var selectElementByClassName = function (target, className) { var _a; return (_a = target.closest('.a-Select')) === null || _a === void 0 ? void 0 : _a.getElementsByClassName(className); };
var getOptionsArray = function (target) {
    var options = selectElementByClassName(target, 'OptionList__option');
    return options
        ? Array.from(options).filter(function (option) {
            return !(option.classList.contains('OptionList__option--disabled') ||
                option.classList.contains('OptionList__option--read-only'));
        })
        : [];
};
exports.getOptionsArray = getOptionsArray;
var getCurrentOptionIndex = function (target, optionsArray) {
    var currentOption = target.closest('.OptionList__option');
    var currentOptionIndex = optionsArray.indexOf(currentOption);
    return currentOptionIndex;
};
var doesHeaderExist = function (target) { var _a; return !!((_a = selectElementByClassName(target, 'Popover__header')) === null || _a === void 0 ? void 0 : _a.length); };
exports.doesHeaderExist = doesHeaderExist;
var doesFooterExist = function (target) { var _a; return !!((_a = selectElementByClassName(target, 'Popover__footer')) === null || _a === void 0 ? void 0 : _a.length); };
exports.doesFooterExist = doesFooterExist;
var focusOption = function (option, closeSelectCallback) {
    var _a, _b;
    if (!option) {
        closeSelectCallback === null || closeSelectCallback === void 0 ? void 0 : closeSelectCallback();
    }
    else {
        (_b = (_a = option) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('label')[0]) === null || _b === void 0 ? void 0 : _b.focus();
    }
};
exports.focusOption = focusOption;
var focusFirstOption = function (target, closeSelectCallback) {
    var optionsArray = exports.getOptionsArray(target);
    var firstOption = exports.getFirstOption(optionsArray, false);
    exports.focusOption(firstOption, closeSelectCallback);
};
exports.focusFirstOption = focusFirstOption;
var focusLastOption = function (target, closeSelectCallback) {
    var optionsArray = exports.getOptionsArray(target);
    var lastOption = exports.getLastOption(optionsArray);
    exports.focusOption(lastOption, closeSelectCallback);
};
exports.focusLastOption = focusLastOption;
var getNextOption = function (target) {
    var optionsArray = exports.getOptionsArray(target);
    var currentOptionIndex = getCurrentOptionIndex(target, optionsArray);
    var nextOption = optionsArray[currentOptionIndex + 1];
    return nextOption === null || nextOption === void 0 ? void 0 : nextOption.getElementsByTagName('label')[0];
};
exports.getNextOption = getNextOption;
var getPreviousOption = function (target) {
    var _a;
    var optionsArray = exports.getOptionsArray(target);
    var currentOptionIndex = getCurrentOptionIndex(target, optionsArray);
    var previousOption = (_a = optionsArray[currentOptionIndex - 1]) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('label')[0];
    return previousOption;
};
exports.getPreviousOption = getPreviousOption;
//# sourceMappingURL=focus-utils.js.map